import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { PoetEntity } from "../../entity";

export class GetAllPoetDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => PoetEntity)
  data!: PoetEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
